import SelectDocumentSec from 'Components/common/assets/svgIcons/SelectDocumentSec';
import SmartCompetitorV2 from 'Components/common/assets/svgIcons/SmartCompetitorV2';
import SmartEvaluationIcon from 'Components/common/assets/svgIcons/SmartEvaluationIcon';
import SmartObjectiveIcon from 'Components/common/assets/svgIcons/SmartObjectiveIcon';
import SmartProductDescription from 'Components/common/assets/svgIcons/SmartProductDescription';
import SmartSelectUploadDocsIcon from 'Components/common/assets/svgIcons/SmartSelectUploadDocsIcon';
import { AccountPlanForm } from 'Types/CompaniesTypes';
import { useSelector } from 'react-redux';
import {
  maxMobile,
  maxWidth,
  primaryColor,
  primaryFont,
  primaryHeadingColor,
  retina,
  wMBold,
  wMedium,
} from 'Utils/utilsStyle';
import classNames from 'classnames';
import React from 'react';
import styled from 'styled-components';

const SliderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 24px;
  .slider-text {
    font-family: ${primaryFont};
    font-weight: ${wMBold};
    font-size: 28px;
    line-height: normal;
    color: ${primaryHeadingColor};
    @media all and (max-width: ${maxWidth}), ${retina} {
      font-size: 22px;
    }
    @media all and (max-width: ${maxMobile}) {
      font-size: 18px;
    }
    .dots {
      font-size: 40px;
      line-height: 0px;
      &.hideDocHub {
        &:nth-child(2) {
          display: none;
        }
      }
      &:first-child {
        margin-left: 5px;
      }
      &.activeDots {
        color: ${primaryColor};
        font-size: 48px;
      }
    }
    &.steps {
      color: #667982;
      font-size: 12px;
      font-weight: ${wMedium};
      display: flex;
      align-items: center;
    }
    &.paragraph {
      font-size: 14px;
      line-height: 16px;
      color: #7E7E7E;
      font-weight: ${wMedium};
      @media all and (max-width: ${maxWidth}), ${retina} {
        font-size: 13px;
      }
    }
    &.title {
      display: flex;
      align-items: center;
      margin-bottom: 12px;
      @media all and (max-width: ${maxWidth}), ${retina} {
        margin-bottom: 6px;
      }
      svg {
        width: 21px;
        height: 21px;
        margin-right: 8px;
      }
      .product-and-description {
        width: 22px;
        height: 24px;
      }
    }
  }
`;

type Props = {
  index?: number;
  title?: string;
  paragraph?: string;
  sliderData: AccountPlanForm[];
  hideDocHub: boolean;
} & typeof defaultProps;

const defaultProps = {
  index: 0,
  title: '',
  paragraph: '',
};

const SmartPlanSliderHeaderComponent = function SmartPlanSliderHeaderComponent(
  props: Props,
) {
  const {
    index, title, paragraph, sliderData, hideDocHub,
  } = props;
  const getIcon = () => {
    if (title === 'Product or Service Description') { return <SmartProductDescription />; }
    if (title === 'Select or Upload documents') { return <SmartSelectUploadDocsIcon />; }
    if (title === 'Objective & Goals') return <SmartObjectiveIcon />;
    if (title === 'Competitor Analysis') return <SmartCompetitorV2 />;
    if (title === 'Select document sections') return <SelectDocumentSec />;
    if (title === 'Measurement & Evaluation') return <SmartEvaluationIcon />;
    return <SmartObjectiveIcon />;
  };
  return (
    <SliderWrapper className="slider-header-component">
      <span className="slider-text title">
        {getIcon()}
        {title}
      </span>
      <p className="slider-text paragraph text-truncate-three-line">
        {paragraph}
      </p>
      <span className={classNames('slider-text steps', { hideDocHub })}>
        Step
        {hideDocHub && index > 0 ? ` ${index}` : ` ${index + 1}`}
        {sliderData.map((slide, slideIndex) => (
          hideDocHub && slideIndex === 1 ? null
            : <span className={classNames('dots', { activeDots: index === slideIndex })}>•</span>
        ))}
      </span>
    </SliderWrapper>
  );
};
export default SmartPlanSliderHeaderComponent;
